import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'shims/process';

import $ from 'jquery';
window.$ = window.jQuery = $;

import 'stylesheets/magic/amalgamation.scss';
import 'stylesheets/autoload/autoload.scss';
import 'javascripts/application';
import 'javascripts/menu_adornments';

const importAll = (r) => r.keys().map(r);
importAll(require.context('../images', true, /\.(png|jpe?g|svg)$/));
